export default __webpack_public_path__ + "static/media/home_banner.6e1e3173.png";